import React, {useEffect, useState} from "react";
import SimpleTable from "../../../common/tables/SimpleTable";
import CapItemPopover from "./CapItemPopover";
import {useDispatch, useSelector} from "react-redux";
import {deleteCapItem, setNeedToReloadCapItems} from "../../../../actions/capItemActions";
import {getRusDateHourString} from "../../../../utils/dateUtils";
import Spinner from "../../../common/Spinner";
import ActionPopover from "../../../common/popovers/ActionPopover";
import {ASC, DESC} from "../../../../utils/constants";
import {sort} from "../../../../utils/sortUtils";
import useResizeObserver from "../../../../hooks/useResizeObserver";
import SearchInput from "../../../navigation/SearchInupt";
import {emptyString} from "../../../../utils/stringUtils";
import {searchByString} from "../../../../utils/searchUtils";
import {getMoneyString} from "../../../../utils/formatUtils";
import {isDesktop, isMobileVerticalScreen} from "../../../../utils/displayUtils";

export default function CapItemTable({}) {

    const dispatch = useDispatch();

    const capItems = useSelector(state => state.capItemReducer.capItems);
    const loading = useSelector(state => state.capItemReducer.loading);

    const [renderedData, setRenderedData] = useState(null);
    const [footerData, setFooterData] = useState(null);
    const [sortingData, setSortingData] = useState({
        sortableColumn: "creationTime",
        sortableDirection: DESC
    });

    const [searchValue, setSearchValue] = useState("");

    const [timeoutState, setTimeoutState] = useState({
        timeout: 0,
    });

    const scrollableHeight = useResizeObserver(document.getElementById("scrollable"))?.height || 0;
    const capServiceTableHeight = useResizeObserver(document.getElementById("capServiceTable"))?.height || 0;

    useEffect(() => {
        dispatch(setNeedToReloadCapItems());
    }, []);

    useEffect(() => {
        if (!capItems) {
            return;
        }
        let renderedData = capItems;
        if (!emptyString(searchValue)) {
            renderedData = renderedData?.map(capItem => { return {...capItem, allPartnerNames: capItem.partners?.map(partner => partner?.name)?.join("__")}})
            renderedData = searchByString(renderedData, ['allPartnerNames', 'capServiceName'], searchValue)
        }
        const {sortableColumn, sortableDirection} = sortingData;
        const directionNumb = !sortableDirection
            ? 0
            : sortableDirection === ASC
                ? 1
                : -1;
        renderedData = sort(renderedData, sortableColumn, directionNumb);
        setRenderedData(renderedData);

    }, [capItems, sortingData.sortableColumn, sortingData.sortableDirection, searchValue])

    useEffect(() => {
        if (!renderedData || renderedData.length === 0) {
            setFooterData(null);
            return;
        }
        const footerData = {partnerNames: "Итого:", maxLimit: 0, spent: 0, remainInPercent: 100};
        renderedData.forEach(item => {
            footerData.maxLimit += item.maxLimit;
            footerData.spent += item.spent;
        });
        footerData.remainInPercent = 100 - (footerData.spent / (footerData.maxLimit) * 100);
        footerData.remainInPercent = getMoneyString(footerData.remainInPercent, 1) + "%";
        setFooterData(footerData);
    }, [renderedData]);


    const deleteCap = (id) => {
        dispatch(deleteCapItem(id, () => dispatch(setNeedToReloadCapItems())))
    }

    const changeSortData = (fieldName, direction) => {
        setSortingData({
            sortableColumn: fieldName,
            sortableDirection: direction
        })
    };

    const changeSearchValue = (value) => {
        if (timeoutState.timeout) {
            clearTimeout(timeoutState.timeout);
        }
        setTimeoutState({
            timeout: setTimeout(() => {
                setSearchValue(value);
            }, 300),
        });

    }

    const getColor = (item) => {
        const remainInPercent = item?.remainInPercent || 0;
        if (item?.isServiceCapLimitExhausted) {
            return "low";
        }
        return remainInPercent < 30
            ? "low"
            : remainInPercent < 70
                ? "mid"
                : "many";
    };

    const getSpentValue = (item) => {
        return <><span>{item["spent"]}</span>{item?.isServiceCapLimitExhausted ? <div style={{fontSize: "10px"}}>(лимит у</div> : null}</>;
    }

    const getRemainInPercent = (item) => {
        return <><span>{getMoneyString(item.remainInPercent, 1) + "%"}</span>{item?.isServiceCapLimitExhausted ? <div style={{fontSize: "10px"}}>оператора)</div> : null}</>;
    }


    const getTableHeight = () => {
        if (!isDesktop()) {
            return "calc(100dvh - 195px)";
        } else {
            return (scrollableHeight - capServiceTableHeight - 10) + "px";
        }

    };

    const tableColumns = () => {
        return [
            {
                name: "Партнёры",
                key: "partnerNames",
                getBodyCellValue: item => item?.partners?.map((partner, idx) =>
                    <span key={partner?.externalId} title={partner?.name}>
                    {partner?.externalId + (idx <  item?.partners.length - 1 ? ", " : "")}
                    </span>) || <div>ВСЕ</div>,
                headerCellStyle: {minWidth: "150px"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "CAP сервис",
                key: "capServiceName",
                getBodyCellValue: item => item["capServiceName"],
                headerCellStyle: {minWidth: "150px", textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "Лимит",
                key: "maxLimit",
                getBodyCellValue: item => item["maxLimit"],
                headerCellStyle: {minWidth: "50px", textAlign: "right"},
                bodyCellStyle: {textAlign: "right"},
            },
            {
                name: "Подписки",
                key: "spent",
                getBodyCellValue: item => <span className={"cap-percent " + getColor(item)}>{getSpentValue(item)}</span>,
                headerCellStyle: {minWidth: "50px", textAlign: "right"},
                bodyCellStyle: {textAlign: "right", paddingRight: "15px"},
                footerClassName: footerItem => "cap-percent " + getColor(footerItem),
            },
            {
                name: "% капы",
                key: "remainInPercent",
                getBodyCellValue: item => <span className={"cap-percent " + getColor(item)}>{getRemainInPercent(item)}</span>,
                headerCellStyle: {minWidth: "50px", textAlign: "right"},
                bodyCellStyle: {textAlign: "right", paddingRight: "15px"},
                footerClassName: footerItem => "cap-percent " + getColor(footerItem),
            },
            {
                name: "Дата добавления",
                key: "creationTime",
                getBodyCellValue: item => item["creationTime"] ? getRusDateHourString(new Date(item["creationTime"])) : "",
                headerCellStyle: {minWidth: "100px", textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: "Дата обновления",
                key: "updateTime",
                getBodyCellValue: item => item["updateTime"] ? getRusDateHourString(new Date(item["updateTime"])) : "",
                headerCellStyle: {minWidth: "100px", textAlign: "left"},
                bodyCellStyle: {textAlign: "left"},
            },
            {
                name: <CapItemPopover button={<i className="ti ti-plus" style={{cursor: "pointer", fontSize: "18px"}}
                                                    title="Добавить"/>}/>,
                key: "actions",
                getBodyCellValue: (item) => <div style={{display: "flex"}}>
                    <CapItemPopover button={<i className="ti ti-pencil td-save" style={{cursor: "pointer", fontSize: "18px"}}
                                                  title="Редактировать"/>} capItem={item}/>
                    <ActionPopover
                        button={<i className="ti ti-trash td-save"/>}
                        tooltip="Удалить"
                        popoverLocation='right'
                        label="Удалить?"
                        handleSubmit={() => deleteCap(item.id)}/>
                </div>,
                bodyCellStyle: {textAlign: "left", minWidth: "105px", width: "105px", paddingRight: "15px"},
                isSortingDisabled: true,
            },
        ]
    };


    return (
        <div className="responsive-block statistic_table_wrapper" id="fullWidth" onScroll={() =>{}} style={{height: getTableHeight()}}>
            <div style={{padding: "5px", backgroundColor: "white"}}>
                <SearchInput searchValue={searchValue} onTextTyping={changeSearchValue} amount={renderedData?.length} allAmount={renderedData?.length} width="100%"/>
            </div>
            {loading
                ? <Spinner/>
                : <SimpleTable tableClassName="table table-bordered nowrap statistic_table sticky-header sticky-action sticky-footer userselecttext" columns={tableColumns()}
                         data={renderedData} bodyRowKey="id" isSortable sortableDirection={sortingData?.sortableDirection}
                               sortableColumn={sortingData?.sortableColumn}  onSort={changeSortData} displayFooterRow footerData={footerData}/>}
        </div>
    )
};